import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.delayTimer = null
    document.addEventListener("turbo:visit", this.scheduleShow)
    document.addEventListener("turbo:before-render", this.hide)
    document.addEventListener("turbo:load", this.hide)
    document.addEventListener("turbo:fetch-request-error", this.hide)
  }

  disconnect() {
    document.removeEventListener("turbo:visit", this.scheduleShow)
    document.removeEventListener("turbo:before-render", this.hide)
    document.removeEventListener("turbo:load", this.hide)
    document.removeEventListener("turbo:fetch-request-error", this.hide)
    this.clearTimer()
  }

  scheduleShow = () => {
    this.clearTimer()
    this.delayTimer = setTimeout(() => {
      this.element.classList.add("turbo-loader--visible")
    }, 200)
  }

  hide = () => {
    this.clearTimer()
    this.element.classList.remove("turbo-loader--visible")
  }

  clearTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer)
      this.delayTimer = null
    }
  }
}
